import React, { useState, useEffect } from 'react';
import { getStyle } from '@coreui/utils';
import { CChart } from '@coreui/react-chartjs';
import { BASE_URL } from "../../App";
import axios from 'axios';

const ChartBarExample = () => {
  const USER_ID = localStorage.getItem("USER_ID");
  const [rawData, setRawData] = useState([]);
  const [chartData, setChartData] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1-based
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const timeBuckets = ['Within 24 Hours', '24 to 48 Hours', 'More than 48 Hours'];

  const fetchChartData = async (monthName) => {
    setLoading(true);
    try {
      const response = await axios.post(BASE_URL + '/customer_enquery_piechart_new', {
        userid: USER_ID,
        selectmonth: monthName,
      });

      const responseData = response.data.data;

      if (responseData && responseData.length > 0) {
        setRawData(responseData);
        setNoData(false);
        processChartData(responseData);
      } else {
        setNoData(true);
      }
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };

  const processChartData = (data) => {
    const statusSet = new Set(data.map(d => d.status));
    const statuses = Array.from(statusSet);

    const grouped = {};
    timeBuckets.forEach(bucket => {
      grouped[bucket] = statuses.map(status => {
        const entry = data.find(d => d.status === status && d.time_bucket === bucket);
        return entry ? entry.total_calls : 0;
      });
    });

    const backgroundColors = {
      'Within 24 Hours': '#36A2EB',
      '24 to 48 Hours': '#FFCE56',
      'More than 48 Hours': '#FF6384'
    };

    const datasets = timeBuckets.map(bucket => ({
      label: bucket,
      backgroundColor: backgroundColors[bucket],
      data: grouped[bucket],
    }));

    setChartData({
      labels: statuses,
      datasets
    });
  };

  useEffect(() => {
    fetchChartData(monthNames[selectedMonth - 1]);
  }, [selectedMonth]);

  const handleMonthChange = (event) => {
    setSelectedMonth(Number(event.target.value));
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: getStyle('--cui-body-color'),
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || '';
            const value = context.raw || 0;
            return `${label}: ${value} call${value !== 1 ? 's' : ''}`;
          }
        }
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: getStyle('--cui-body-color') },
        grid: { display: false }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: { color: getStyle('--cui-body-color') },
        grid: { color: '#e4e5e7' }
      }
    }
  };

  return (
    <div className='row'>
      <div className='col-md-12'>
        <h3>Service Calls Count - {monthNames[selectedMonth - 1]}</h3>

        <div style={{ marginBottom: '1rem' }}>
          <select value={selectedMonth} onChange={handleMonthChange}>
            {monthNames.map((name, index) => (
              <option key={index} value={index + 1}>{name}</option>
            ))}
          </select>
        </div>

        {loading && <div>Loading...</div>}
        {noData && !loading && <div>No data available for {monthNames[selectedMonth - 1]}</div>}
        {!loading && !noData && (
          <div style={{ width: '100%', height: '600px' }}>
            <CChart type="bar" data={chartData} options={options} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartBarExample;
